/**
 * @group DOM Attribute
 */
export const TIMING_START = 'timing-start';

/**
 * @group DOM Attribute
 */
export const TIMING_END = 'timing-end';
